import * as React from 'react';
import { withRouter, WithRouterProps } from 'react-router';
import bind from '../bind';
import { withUpdateURL, IUpdateURLProps } from './with_update_url';
import { Filter } from './search_filters';

interface ExternalProps {
  sort: Filter;
}

type IProps = ExternalProps & WithRouterProps & IUpdateURLProps;

export class SortSelect extends React.Component<IProps, {}> {
  @bind
  sortChanged(evt: React.ChangeEvent<HTMLSelectElement>) {
    const sort = evt.target.value;
    evt.target.blur();
    const { paramName } = this.props.sort.options[0];
    const newUrl = this.props.updateUrl(this.props.location, { [paramName]: sort });
    this.props.router.push(newUrl);
  }

  render() {
    const sortOptions = this.props.sort.options.map(option => (
      <option key={option.optionValue} value={option.optionValue}>
        {option.name}
      </option>
    ));
    const selected = this.props.sort.options.find(opt => opt.selected);

    return (
      <div className="styled-dropdown styled-dropdown--fluid mb-0">
        <select
          onChange={this.sortChanged}
          value={selected && selected.optionValue}
          name="sort"
          id="sort"
        >
          {sortOptions}
        </select>
      </div>
    );
  }
}

export default withRouter<ExternalProps>(withUpdateURL(SortSelect));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/sort_select.tsx